module.exports = __webpack_public_path__ + "src/assets/models/leaves/road_sign.fbx";